class IntercomClient {
  setUser = () => {
    return
  }

  updateUser = () => {
    return
  }

  reset = () => {
    return
  }

  showIntercomMessenger = () => {
    return
  }

  sendTokenToIntercom = () => {
    return
  }
}

export default new IntercomClient()
